import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-44113da4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "tuishui"
};
const _hoisted_2 = {
  class: "panel"
};
const _hoisted_3 = {
  class: "panel-body"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("快捷设置");

const _hoisted_5 = {
  style: {
    "margin": "20px"
  }
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_8 = {
  class: "panel-title"
};
const _hoisted_9 = {
  class: "panel-body"
};
const _hoisted_10 = {
  style: {
    "margin": "20px"
  }
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("返回");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_table, {
    data: $data.type_list,
    border: "",
    small: "",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row",
    "table-layout": "auto"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "name",
      label: "交易类型",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", {
        class: "type-color",
        style: _normalizeStyle({
          borderColor: scope.row.type_color
        })
      }, _toDisplayString(scope.row.game_type), 5)]),
      _: 1
    }), $props.userinfo.level_id == 0 || $props.userinfo.level_id.includes('1') ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 0,
      prop: "water_break_A",
      label: "A盘",
      align: "center",
      width: "100"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        min: 0,
        modelValue: scope.row.water_break_A,
        "onUpdate:modelValue": $event => scope.row.water_break_A = $event
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), $props.userinfo.level_id == 0 || $props.userinfo.level_id.includes('2') ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 1,
      prop: "water_break_B",
      label: "B盘",
      align: "center",
      width: "100"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        min: 0,
        modelValue: scope.row.water_break_B,
        "onUpdate:modelValue": $event => scope.row.water_break_B = $event
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), $props.userinfo.level_id == 0 || $props.userinfo.level_id.includes('3') ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 2,
      prop: "water_break_C",
      label: "C盘",
      align: "center",
      width: "100"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        min: 0,
        modelValue: scope.row.water_break_C,
        "onUpdate:modelValue": $event => scope.row.water_break_C = $event
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), $props.userinfo.group_id == 2 || $props.userinfo.group_id == 3 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 3,
      prop: "straightbet_low",
      label: "单注最低",
      align: "center",
      width: "100"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        min: 0,
        modelValue: scope.row.straightbet_low,
        "onUpdate:modelValue": $event => scope.row.straightbet_low = $event
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
      prop: "straightbet_high",
      label: "单注限额",
      align: "center",
      width: "100"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        min: 0,
        modelValue: scope.row.straightbet_high,
        "onUpdate:modelValue": $event => scope.row.straightbet_high = $event
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "single_high",
      label: "单期限额",
      align: "center",
      width: "100"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        min: 0,
        modelValue: scope.row.single_high,
        "onUpdate:modelValue": $event => scope.row.single_high = $event
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "",
      label: "操作",
      align: "center",
      width: "100"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        onClick: $event => $options.fast_set(scope.row)
      }, {
        default: _withCtx(() => [_hoisted_4]),
        _: 2
      }, 1032, ["onClick"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"])])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
    type: "warning",
    size: "small",
    onClick: $options.sub
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    size: "small",
    onClick: $options.back
  }, {
    default: _withCtx(() => [_hoisted_7]),
    _: 1
  }, 8, ["onClick"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, game => {
    return _openBlock(), _createElementBlock("div", {
      class: "panel",
      key: game.gname,
      style: {
        "margin": "10px 0"
      }
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("h2", null, _toDisplayString(game.gname), 1)]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(game.list, list => {
        return _openBlock(), _createBlock(_component_el_col, {
          key: list,
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table, {
            data: list,
            border: "",
            small: "",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "name",
              label: "交易类型",
              align: "right"
            }, {
              default: _withCtx(scope => [_createElementVNode("div", {
                class: "type-color",
                style: _normalizeStyle({
                  borderColor: scope.row.type_color
                })
              }, _toDisplayString(scope.row.name), 5)]),
              _: 1
            }), $props.userinfo.level_id == 0 || $props.userinfo.level_id.includes('1') ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "water_break_A",
              label: "A盘",
              align: "center",
              width: "80"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input, {
                size: "small",
                min: 0,
                modelValue: scope.row.water_break_A,
                "onUpdate:modelValue": $event => scope.row.water_break_A = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), $props.userinfo.level_id == 0 || $props.userinfo.level_id.includes('2') ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "water_break_B",
              label: "B盘",
              align: "center",
              width: "80"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input, {
                size: "small",
                min: 0,
                modelValue: scope.row.water_break_B,
                "onUpdate:modelValue": $event => scope.row.water_break_B = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), $props.userinfo.level_id == 0 || $props.userinfo.level_id.includes('3') ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "water_break_C",
              label: "C盘",
              align: "center",
              width: "80"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input, {
                size: "small",
                min: 0,
                modelValue: scope.row.water_break_C,
                "onUpdate:modelValue": $event => scope.row.water_break_C = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), $props.userinfo.group_id == 2 || $props.userinfo.group_id == 3 ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              prop: "straightbet_low",
              label: "单注最低",
              align: "center",
              width: "80"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input, {
                size: "small",
                min: 0,
                modelValue: scope.row.straightbet_low,
                "onUpdate:modelValue": $event => scope.row.straightbet_low = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
              prop: "straightbet_high",
              label: "单注限额",
              align: "center",
              width: "100"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input, {
                size: "small",
                min: 0,
                modelValue: scope.row.straightbet_high,
                "onUpdate:modelValue": $event => scope.row.straightbet_high = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "single_high",
              label: "单期限额",
              align: "center",
              width: "100"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input, {
                size: "small",
                min: 0,
                modelValue: scope.row.single_high,
                "onUpdate:modelValue": $event => scope.row.single_high = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            })]),
            _: 2
          }, 1032, ["data"])]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 2
    }, 1024)])]);
  }), 128)), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
    type: "warning",
    size: "small",
    onClick: $options.sub
  }, {
    default: _withCtx(() => [_hoisted_11]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    size: "small",
    onClick: $options.back
  }, {
    default: _withCtx(() => [_hoisted_12]),
    _: 1
  }, 8, ["onClick"])])]);
}